import React, {Component} from 'react';
import { Provider, connect } from 'react-redux';
import {
    BrowserRouter as Router,
    Route,
    Redirect,
    withRouter,
    Switch
} from "react-router-dom";
import {Carousel} from 'antd';
import Index from './Index';
import Login from './Login';
import Layout from './Layout';
import Enquire from './Enquire';
import Signup from './Signup';
import ProviderRoot from './provider/Root';
import ContractorRoot from './contractor/Root';
import {fetchMe} from '../actions';

const App = ({isAuthenticated, roles, isFetching}) => {
    const role = roles.map(r => r.name).pop();
    if ((!role && isAuthenticated) || isFetching) return null;

    const redirectRoutes = {
        superadmin: '/admin',
        landlord: '/provider/profile',
        contractor: '/contractor/profile',
    };
    return <Switch>
        <Route exact path="/" render={props => {
            if (isAuthenticated) {
                return <Redirect to={redirectRoutes[role]}/>
            }

            return (
                <Layout>
                    <Carousel effect="fade">
                        <div><h3>1</h3></div>
                        <div><h3>2</h3></div>
                        <div><h3>3</h3></div>
                        <div><h3>4</h3></div>
                    </Carousel>
                </Layout>
            )
        }}/>

        {isAuthenticated && role === 'superadmin' ? <Route path="/admin" component={Index}/> : null}
        {isAuthenticated && role === 'landlord' ? <Route path="/provider" component={ProviderRoot}/> : null}
        {isAuthenticated && role === 'contractor' ? <Route path="/contractor" component={ContractorRoot}/> : null}
        <Route path="/enquire" render={props => {
            return (
                <Layout>
                    <Enquire />
                </Layout>
            )
        }} />
        <Route path="/login" component={Login} />
        <Route path="/signup" render={props => {
            if (isAuthenticated) {
                return <Redirect to="/"/>
            }
            return <Signup/>
        }} />
    </Switch>
};

const mapStateToProps = (state) => {
    return {...state.auth, ...state.me};
};
const Wrapped = withRouter(connect(mapStateToProps)(App));

export default class Root extends Component {
    componentDidMount() {
        const {store} = this.props;
        const {auth: {isAuthenticated}} = store.getState();

        if (isAuthenticated) {
            return store.dispatch(fetchMe());
        }
    }
    render() {
        const {store} = this.props;
        return (
            <Provider store={store}>
                <Router>
                    <Wrapped />
                </Router>
            </Provider>
        );
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/Root.js